// Reset is not native to Remix, so we need to create a custom hook to reset the fetcher data.
// Has been requested by community but not yet implemented, so workaround is provided by maintainers:
// https://github.com/remix-run/remix/discussions/2749#discussioncomment-7276763

import { useEffect, useState } from "react";
import { type FetcherWithComponents, useFetcher } from "react-router";
import type { SerializeFrom } from "~/modules/routing/types";

export type FetcherWithComponentsReset<T> = FetcherWithComponents<
  SerializeFrom<T>
> & {
  reset: () => void;
};

export function useFetcherWithReset<T>(
  opts?: Parameters<typeof useFetcher>[0],
): FetcherWithComponentsReset<T> {
  const fetcher = useFetcher<T>(opts);
  const [data, setData] = useState(fetcher.data);

  useEffect(() => {
    if (fetcher.state === "idle") {
      setData(fetcher.data);
    }
  }, [fetcher.state, fetcher.data]);

  return {
    ...fetcher,
    data: data as SerializeFrom<T>,
    reset: () => setData(undefined),
  };
}
